import { useCallback, useEffect, useState } from "react";
import axios from "../../../../api/apiClient";
import { domain, token } from "../../../Security";

export function ClassificationIdSelect({ classificationId, setClassificationId, user }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/Classification/active/username/${user.username}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      setData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [user]);

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, classificationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose classification</option>
        {data.map((classificationId) => (
          SetClassificationId(classificationId)
        ))}
      </select>
    </div>
  );
};

function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{
      classificationId.description}
    </option>
  )
}